import './Header.svelte.css';
/* src/components/Header.svelte generated by Svelte v3.57.0 */
import {
	SvelteComponent,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	space
} from "../../_snowpack/pkg/svelte/internal.js";

function create_fragment(ctx) {
	let h1;
	let t1;
	let p;

	return {
		c() {
			h1 = element("h1");
			h1.textContent = "Excelsior";
			t1 = space();
			p = element("p");
			p.textContent = "Uma alternativa para planilhas quando você estiver trabalhando com dados não\n  tabulares. Defina fórmulas usando os nomes dos símbolos em vez do nome das\n  células onde eles se encontram. Visualize suas fórmulas com maior\n  facilidade.";
			attr(p, "class", "svelte-11zfrei");
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			insert(target, t1, anchor);
			insert(target, p, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t1);
			if (detaching) detach(p);
		}
	};
}

class Header extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Header;